const SOLUTIONS_NAV_LINKS = [
  {
    id: 1,
    label: "Talent Intelligence",
    path: "/services/solutions/talent-intelligence",
    navStyles: "p-2 pl-4 mt-2 rounded-md hover:bg-blue-500"
  },
  {
    id: 3,
    label: "Product Engineering",
    path: "/services/solutions/product-engineering",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500"
  },
  {
    id: 4,
    label: "Data, AI & Intelligent Automation",
    path: "/services/solutions/data-ai-analytics",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500"
  },
  {
    id: 5,
    label: "Cloud & DevOps",
    path: "/services/solutions/cloud-devops-security",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500"
  }
];

const PRODUCTS_NAV_LINKS = [
  {
    id: 1,
    label: "Prohirey",
    path: "https://prohirey.com",
    navStyles: "p-2 pl-4 mt-2 rounded-md hover:bg-blue-500",
    isExternal: true
  },
  {
    id: 2,
    label: "ToxBox AI",
    path: "https://toxboxai.com",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500",
    isExternal: true
  },
  {
    id: 3,
    label: "Sailsense AI",
    path: "https://admin.provaantech.com",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500",
    isExternal: true
  },
  {
    id: 4,
    label: "SaleSense Kiosk | Interactive Deal Studio",
    path: "https://admin.provaantech.com/kiosk",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500",
    isExternal: true
  }
];

const INDUSTRIES_NAV_LINKS = [
  {
    id: 1,
    label: "Manufacturing",
    path: "/industries/manufacturing-industrial-energy",
    navStyles: "p-2 pl-4 mt-2 rounded-md hover:bg-blue-500"
  },
  {
    id: 2,
    label: "Healthcare",
    path: "/industries/healthcare-life-sciences",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500"
  },
  {
    id: 3,
    label: "BFSI",
    path: "/industries/bfsi",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500"
  },
  {
    id: 4,
    label: "Retail",
    path: "/industries/communications-media-retail",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500"
  },
  {
    id: 5,
    label: "Technology",
    path: "/industries/automotive-aerospace-defence-technology",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500"
  },
  {
    id: 6,
    label: "Energy",
    path: "/industries/manufacturing-industrial-energy",
    navStyles: "p-2 pl-4 rounded-md hover:bg-blue-500"
  }
];

export { SOLUTIONS_NAV_LINKS, PRODUCTS_NAV_LINKS, INDUSTRIES_NAV_LINKS };